import styled from 'styled-components';

export const FooterContainer = styled.div`
    padding: 10vh 15vw;
`;
